import styled from "styled-components";

import Containerimg from '../../../assets/combined.svg'
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100vh;

    display: flex;
    align-items: center;
    align-items: flex-start;
    
    background-color: ${theme.colors.white.Branco};
    background-image: url(${Containerimg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: 100%;
    padding: 0rem 3rem 3rem;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    >img{
        width: auto;
        height: 2.25rem;
    }

`;

export const Content = styled.div` 
    width: 100%;
    height: auto;
    padding: 1.5rem 0;
    
    gap: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    >img{
        width: auto;
        height: 10rem;
    }

    >h1{
        text-align: center;

        @media (max-width: 768px){
            font-size: 1.5rem;
            line-height: normal;
        }
    }

    >span{
        color: transparent;
    }
`;

export const Description = styled.div` 
    width: 100%;
    height: auto;
    
    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    >p{
        text-align: center;

        >span{
            text-align: center;
        }
    }

    >p + p{
        text-align: center;
    }
`;

export const Button = styled.button` 
    width: 8.875rem;
    height: 3.5rem;
    padding: 0.75rem 2.5rem;

    border: none;
    cursor: pointer;
    border-radius: 10rem;
    background-color: ${theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer;
        text-align: center;
    }
`;
